import { IAjaxCreationMethod } from '@microsoft/portal-app/lib/auth';
import { addAjaxEpic } from '@microsoft/portal-app/lib/redux/createAjaxEpic';
import { getOrgContactInsightsSettingsReq } from '../../../redux/modules/graphApis';
import { IRootUserState } from '@microsoft/portal-app/lib/User/models';
import { getTenantId } from '@microsoft/portal-app/lib/User/getTenantId';
import { IPrivacyAction } from '../../models/IPrivacyActions';
import { IPrivacyState } from '../../models/IPrivacyState';
import { PrivacyActions } from '../../models/PrivacyActions';
import { privacyRegistry as registry } from '../privacyRegistry';

export const getOrgContactInsightsStatusResponse = (
  state: IPrivacyState,
  action: IPrivacyAction<{ response: { isEnabledInOrganization: boolean } }>,
): IPrivacyState => {
  const payload = action.payload;
  if (payload) {
    const isEnabledInOrganization = !!payload?.response?.isEnabledInOrganization;

    const nextState: IPrivacyState = {
      ...state,
      orgContactInsightsState: isEnabledInOrganization,
    };
    return nextState;
  }
  return state;
};

export const getOrgContactInsightsStatusFailed = (state: IPrivacyState): IPrivacyState => {
  return state;
};

export const getOrgContactInsightsStatus = (ajax: IAjaxCreationMethod, _action: IPrivacyAction, state: IRootUserState) => {
  const tenantId = getTenantId(state) as string;
  return ajax(getOrgContactInsightsSettingsReq(tenantId)).pipe();
};

addAjaxEpic(registry, PrivacyActions.getOrgContactInsightsStatus, getOrgContactInsightsStatus, {
  statePropertyName: 'orgContactInsightsState',
  loadingFailedReducer: getOrgContactInsightsStatusFailed,
  loadingSuccessReducer: getOrgContactInsightsStatusResponse,
});
